export default {
  pages: [],
  listings: [],
  selectedpagecategory: {},
  pageCategories: [],
  selectedBlog: {},
  filtertags: [],
  filters: [],
  categorywisepages: [],
  categorywisepagesforblog: {},
  categorywisepagesforevent: {},
  careers: [],
  selectedCareer: {},
  selectedpdf: {},
};
